import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Comment.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaPlane } from 'react-icons/fa';
import { faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import useWindowWidth from '~/hooks/useWindowWidth';

const cx = classNames.bind(styles);

function Comment({ comments, formRef, listRef, onAddComment }) {
  const commentRef = useRef();
  const windowWidth = useWindowWidth();


  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onAddComment(e);
    }
  };

  return (
    <div className={cx('commentSection')} ref={commentRef}>
      <div className={cx('commentList')} ref={listRef}>
        {comments.length > 0
          ? comments.map((comment, index) => (
              <div key={index} className={cx('comment')}>
                <p className={cx('commentContent')}>{comment.content}</p>
                <em className={cx('commentDate')}>{comment.date_create}</em>
              </div>
            ))
          : 'Hãy là người bình luận đầu tiên'}
        {/* <p onClick={() => setcountComment((prev) => prev + 1)}>Xem thêm</p> */}
      </div>
      <form ref={formRef} className={cx('comment-action', { fixed: true })}>
        <input
          type="text"
          name="content"
          placeholder="Add a comment..."
          className={cx('input')}
          // onFocus={handleFocusInput}
          onKeyDown={handleKeyDown}
        />
        <button type="submit" onClick={onAddComment} className={cx('button')}>
          {windowWidth > 3 ? 'Comment' : <FontAwesomeIcon icon={faPaperPlane} />}
        </button>
      </form>
    </div>
  );
}

export default Comment;
